//shamelessly stolen from: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/samples/react-sample-app/src/auth-utils.js
import { UserAgentApplication } from 'msal';

function isIE() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ') > -1;
  const msie11 = ua.indexOf('Trident/') > -1;

  // If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
  // const isEdge = ua.indexOf("Edge/") > -1;
  return msie || msie11;
}

export const msalApp = new UserAgentApplication({
  auth: {
    clientId: '50f75f31-5091-420a-a6b8-9303e8da06fd',
    authority: 'https://login.microsoftonline.com/common',
    validateAuthority: true,
    postLogoutRedirectUri: 'https://teamsapp.mubs.edu.lb/',
    navigateToLoginRequestUrl: false
  },
cache: {
    cacheLocation: "localStorage", // Change from sessionStorage to localStorage
    storeAuthStateInCookie: true,   // Set this to true to help with loops
},
  system: {
    navigateFrameWait: 0
  }
});